import { UserType } from "../api/authService";

// Each role has its own URL section (admin/business-owner/delivery/delivery-company,
// client at the root), but only one role's session is ever stored at a time. This maps
// a pathname to the role it belongs to, so a stored session can be masked/ignored
// outside of its own section instead of leaking into whichever section is on screen.
export function getExpectedUserType(pathname) {
  if (pathname.startsWith("/admin")) return UserType.Admin;
  if (pathname.startsWith("/business-owner")) return UserType.BusinessOwner;
  if (pathname.startsWith("/delivry-company")) return UserType.DeliveryCompany;
  if (pathname.startsWith("/delivery")) return UserType.Delivery;
  return UserType.User;
}
